import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { STRING_SUB_MENU, STRING_MENU } from "../../../../constants/string";
import { usePageTitle } from "../../../../hooks/usePageTitle";
import { toggleMenuContent, setSidebarMenu, setSidebarMenuSub } from "../../../../store/themeConfigSlice";
import AttendancePersonalFilter from "../components/attendance-personal-filter";
import AttendancePersonalTable from "../components/attendance-personal-table";
import { getCurrentMonth } from "../../../../utils/time-utils";
import { AttendanceService } from "../../attendance/services/attendance-service";
import useDebounce from "../../../../hooks/useDebounce";
import CookieUtils from "../../../../utils/cookie-utils";
import { useDataResponse } from "../../../../hooks/useResponseHandler";
import AttendanceManagementDetailModal from "../../attendance/modals/attendance-management-detail-modal";
import { AttendanceRecord } from "../types/attendance";
import { ATTENDANCE_MODE } from "../../../../constants/status";

const AttendancePersonalPage = () => {

    const dispatch = useDispatch();
    usePageTitle(STRING_SUB_MENU.ATTENDANCE_PERSONAL);
    useEffect(() => {
        dispatch(toggleMenuContent(STRING_SUB_MENU.ATTENDANCE_PERSONAL));
        dispatch(setSidebarMenu(STRING_MENU.HUMAN_RESOURCE_MANAGEMENT));
        dispatch(setSidebarMenuSub(STRING_SUB_MENU.PAYROLL_MANAGEMENT));
    }, []);

    const [dataStringInput, setDateStringInput] = useState(getCurrentMonth());
    const [dataString, setDateString] = useState(dataStringInput);
    const [dateState, setDateState] = useState({ month: 0, year: 0 });
    const [dataTable, setDataTable] = useState<any[]>([])

    const [isShowModalDetail, setIsShowModalDetail] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<AttendanceRecord[]>([]);

    const { fetch: onGetAttendance, response: resAttendance, loading } = AttendanceService.getAttendance();
    // Chế độ chấm công của NV đang xem — cần fetch riêng vì NV NO_ATTENDANCE (quản lý/tài xế/kiểm
    // đếm) KHÔNG BAO GIỜ có attendance_record (xem hrm AttendanceRecordSchedulerService), nên khi cả
    // tháng không có record nào thì không có cách nào suy ra chế độ từ dataTable rỗng. Tái dùng đúng
    // API check-in-status đã có sẵn cho nút chấm công trên header.
    const { fetch: onGetCheckInStatus, response: resCheckInStatus } = AttendanceService.checkInStatus();

    useEffect(() => {
        const [month, year] = dataString.split("/")
        setDateState({ month: Number(month), year: Number(year) })
        onGetAttendance({
            month: dataString,
            user_id: CookieUtils.getCurrentUser().id ?? 0
        })
    }, [dataString])

    useEffect(() => {
        onGetCheckInStatus();
    }, [])

    useDebounce(() => {
        setDateString(dataStringInput);
    }, 500, [dataStringInput]);

    useDataResponse(resAttendance, setDataTable)

    const [attendanceMode, setAttendanceMode] = useState<ATTENDANCE_MODE | undefined>(undefined);
    useDataResponse(resCheckInStatus, (data) => setAttendanceMode(data.attendance_mode))

    return (
        <>
            <div className="flex flex-col gap-3 panel">
                <AttendancePersonalFilter
                    dateTime={dataString}
                    setDateTime={setDateStringInput}
                />

                {attendanceMode === ATTENDANCE_MODE.NO_ATTENDANCE && (
                    <div className="p-3 text-sm text-gray-600 border border-gray-200 rounded-lg bg-gray-50">
                        Bạn thuộc nhóm <b>không chấm công</b> (quản lý/tài xế/kiểm đếm) — công được tính theo
                        hình thức khác (không theo giờ vào/ra), nên bảng dưới đây sẽ luôn trống.
                    </div>
                )}

                <AttendancePersonalTable
                    dataTable={dataTable}
                    loadingTable={loading}
                    dateState={dateState}
                    attendanceMode={attendanceMode}
                    onShowDetail={(selectedItems) => {
                        setSelectedRecord(selectedItems)
                        setIsShowModalDetail(true)
                    }}
                />
            </div>

            <AttendanceManagementDetailModal
                isShow={isShowModalDetail}
                onClose={() => setIsShowModalDetail(false)}
                selectedRecord={selectedRecord}
            />
        </>
    )
}

export default AttendancePersonalPage